/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StoreProfileAccessibility
 */
export interface StoreProfileAccessibility {
    /**
     * 
     * @type {string}
     * @memberof StoreProfileAccessibility
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof StoreProfileAccessibility
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof StoreProfileAccessibility
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof StoreProfileAccessibility
     */
    icon: string;
}

/**
 * Check if a given object implements the StoreProfileAccessibility interface.
 */
export function instanceOfStoreProfileAccessibility(value: object): value is StoreProfileAccessibility {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('icon' in value) || value['icon'] === undefined) return false;
    return true;
}

export function StoreProfileAccessibilityFromJSON(json: any): StoreProfileAccessibility {
    return StoreProfileAccessibilityFromJSONTyped(json, false);
}

export function StoreProfileAccessibilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): StoreProfileAccessibility {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'name': json['name'],
        'description': json['description'],
        'icon': json['icon'],
    };
}

export function StoreProfileAccessibilityToJSON(json: any): StoreProfileAccessibility {
    return StoreProfileAccessibilityToJSONTyped(json, false);
}

export function StoreProfileAccessibilityToJSONTyped(value?: StoreProfileAccessibility | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'name': value['name'],
        'description': value['description'],
        'icon': value['icon'],
    };
}

